import { Typography } from "@mui/material"
import { Box, Grid } from "@mui/system"

export const ReportsHeader = ({ ncrData, userData }) => {

  return (
    <Box sx={{ width: '100%', pt: 2 }}>
      <Grid container spacing={1}>
        <Grid item size={{ xs: 6, md: 5.5 }}>
          <Typography sx={{ fontSize: '14px' }} className="default-text">
            Name:
            <span>
              <Typography component="span" className="default-text reports-text-content" sx={{ fontSize: '14px', pl: 1 }}>
                {userData?.fullName || 'No data found'}
              </Typography>
            </span>
          </Typography>
        </Grid>

        <Grid item size={{ xs: 6, md: 3 }}>
          <Typography sx={{ fontSize: '14px' }} className="default-text">
            NC ID:
            <span>
              <Typography component="span" className="default-text reports-text-content" sx={{ fontSize: '14px', pl: 1 }}>
                {ncrData?.ncr_id || 'No data found'}
              </Typography>
            </span>
          </Typography>
        </Grid>

        <Grid item size={{ xs: 6, md: 3.5 }} sx={{ textAlign: "right" }}>
          <Typography sx={{ fontSize: '14px' }} className="default-text">
            NC Date:
            <span>
              <Typography component="span" className="default-text reports-text-content" sx={{ fontSize: '14px', pl: 1 }}>
                {ncrData?.date_of_issue
                  ? new Date(ncrData.date_of_issue).toLocaleDateString('en-IN', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  })
                  : 'No data found'}
              </Typography>
            </span>
          </Typography>
        </Grid>

        <Grid item size={{ xs: 6, md: 5.5 }}>
          <Typography sx={{ fontSize: '14px' }} className="default-text">
            Part/ Component number:
            <span>
              <Typography component="span" className="default-text reports-text-content" sx={{ fontSize: '14px', pl: 1 }}>
                {ncrData?.affected_item_component_no || 'No data found'}
              </Typography>
            </span>
          </Typography>
        </Grid>

        <Grid item size={{ xs: 6, md: 3 }}>
          <Typography sx={{ fontSize: '14px' }} className="default-text">
            Qty:
            <span>
              <Typography component="span" className="default-text reports-text-content" sx={{ fontSize: '14px', pl: 1 }}>
                {ncrData?.affected_item_qty || 'No data found'}
              </Typography>
            </span>
          </Typography>
        </Grid>

        <Grid item size={{ xs: 6, md: 3.5 }} sx={{ textAlign: "right" }}>
          <Typography sx={{ fontSize: '14px' }} className="default-text">
            Supplier or Customer name:
            <span>
              <Typography component="span" className="default-text reports-text-content" sx={{ fontSize: '14px', pl: 1 }}>
                {ncrData?.affected_item_supplier_cust_name || 'No data found'}
              </Typography>
            </span>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography sx={{ fontSize: '14px' }} className="default-text">
            Description:
            <span>
              <Typography component="span" className="default-text reports-text-content" sx={{ fontSize: '14px', pl: 1 }}>
                {ncrData?.affected_item_description || 'No data found'}
              </Typography>
            </span>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}